export default __webpack_public_path__ + "static/system-integration-perche-importante-per-aziende-orangeloop-eca17fb57c8a2523e17cd404de73a79c.jpg";